export default "__VITE_ASSET__Bgxh9Ufz__"